import React, { useContext } from 'react';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';

import { Typography } from '@comparethemarketau/manor-typography';

const useStyles = createUseStyles((theme) => ({
    container: {
        display: 'flex',
        gap: '0.4rem',
        color: theme.colors.error500
    },
    text: {
        fontSize: theme.fontSize.sm,
        lineHeight: '1.8rem'
    },
    iconContainer: {
        lineHeight: '1.9rem'
    },
    icon: {
        fontSize: theme.fontSize.sm
    }
}));

const CallBackFailure = () => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <div className={classNames('test-callBack-failure', classes.container)}>
            <Typography className={classes.iconContainer}><FontAwesomeIcon icon={faExclamationCircle} className={classes.icon} /></Typography>
            <Typography className={classes.text}>{'Sorry, something went wrong when sending your callback request. Please try again.'}</Typography>
        </div>
    );
};

export { CallBackFailure };
